import { Component, ViewChild, Output, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { getApp } from "../app";

@Component({
    selector: "app-override-mpnFields",
    templateUrl: "./override-mpnFields-modal.component.html",
    styleUrls: ["./override-mpnFields-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverrideMpnFieldsModalComponent implements OnInit {
  @ViewChild("overrideMpnFields", { static: false })
  overrideMpnFields: any;
  @Output()
  ok = new Subject<any>();
  private isOpen = false;

  app = getApp((app) => {
    this.app = app;
  });

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    this.app.overrideMpnFields.manufacturerKeys =
      this.app.list.RM.manufacturerMappingFields;
    this.app.overrideMpnFields.partKeys = this.app.list.RM.partMappingFields;
  }

  getPartKeysWithValues() {
    return this.getKeysWithValues(
      this.app.overrideMpnFields.partKeys,
      this.app.manufacturer.selectedPart
    );
  }

  getManufacturerKeysWithValues() {
    return this.getKeysWithValues(
      this.app.overrideMpnFields.manufacturerKeys,
      this.app.manufacturer.selectedManufacturer
    );
  }

  private getKeysWithValues(keys: string[], doc: any) {
    if (doc == null || Object.keys(doc).length === 0) {
      return [];
    }

    return keys.filter((key) => this.hasValue(doc[key.split(".")[1]]));
  }

  private hasValue(value: any) {
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (typeof value === "string") {
      return value.trim() !== "" && value.trim() !== "-";
    }

    return value !== null && value !== undefined;
  }

  async open() {
    if (this.isOpen) {
      return;
    }

    this.isOpen = true;
    try {
      const result = await this.modalService.open(this.overrideMpnFields, {
        windowClass: "overrideMpnFieldsModal",
        backdrop: "static"
      }).result;
      this.ok.next(result);
    } catch (err) {
    } finally {
      this.isOpen = false;
    }
  }

  async closeModal() {
    this.app.overrideMpnFields.openOverrideModal = false;
    // reset partsToVehicles data to avoid the generation of the open impacts on the case
    const partNumber =
      this.app.thread.thread[this.app.fieldId.thread.artNumber];
    if (partNumber) {
      await this.app.treeRow.generateImpactsFromParts(partNumber);
    }

    this.app.thread.isCreatedFromAlert = false;
    this.app.thread.isCreatedFromMPN = false;
    this.app.overrideMpnFields.selectedField = "";

    this.app.thread.modalSubject.next("");
    this.modalService.dismissAll();
  }
}
